import React from 'react';
import '../WebflowCss/ark-payment.webflow.css';
import { RoundButton } from './Common/index';
import Icon from '../assets/images/Icon-K.svg';
import SmartphoneImage from '../assets/images/ark_phone.svg';

export const StartSection = () => {
  return (
    <div className="header-section">
      <div className="start-screen">
        <div className="start-text-block">
          <img src={Icon} loading="lazy" alt="" className="image-k" />
          <div className="start-text">Payment</div>
          <div className="start-text green">revolutionized</div>
          <RoundButton text="Drive into the future" onClick />
        </div>
        <img src={SmartphoneImage} loading="lazy" alt="" className="start-image-animated" />
      </div>
    </div>
  );
};
